var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacescanCorners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facescan-corners_svg__circle",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 885 885"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".facescan-corners_svg__cls-1{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "facescan-corners_svg__cls-1",
    d: "M241.57 804.03H93.22V655.66h17.27v131.09h131.08v17.28zM110.49 229.31H93.22V80.97h148.35v17.28H110.49v131.06zM791.78 229.31h-17.27V98.25H643.42V80.97h148.36v148.34zM791.78 804.03H643.42v-17.28h131.09V655.66h17.27v148.37z"
  })));
}
export default __webpack_public_path__ + "3bf19c55c3f629f715854db928ab6faf.svg";
export { SvgFacescanCorners as ReactComponent };